(function ($) {
  var _duration = 1000,
    _easing = "easeOutCubic",
    _width = window.innerWidth,
    _windowWidth = window.innerWidth,
    _windowHeight = window.innerHeight,
    _spmode = 768,
    _speed = 1000;
  _winScrollTop = 0;


  window.onload = function () {
    hideFormButton();
    handleMediaVariant();
    handleVariantSelector();
    updatePreorderLimit();
    handleQuantitySelector();
    handleAddCartButton();
    disableCartForm();
    handleBtnWishList();
    handleSliders();
  };
  function handleSliders(){;
    slickSlider('.slide_master', {
      asNavFor: '.slide_small',
      fade: false,
      autoplay: false,
      arrows: false,
      dots: false,
      adaptiveHeight: true,
      variableWidth: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            centerPadding: '0',
          }
        }
      ]
    });
    slickSlider('.slide_small', {
      asNavFor: '.slide_master',
      fade: false,
      autoplay: false,
      infinite: true,
      arrows: true,
      dots: false,
      adaptiveHeight: true,
      variableWidth: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      focusOnSelect: true,
      prevArrow: $('.btn_prev'),
      nextArrow: $('.btn_next'),
      responsive: [
        {
          breakpoint: 960,
          settings: {
            centerPadding: '0',
          }
        }
      ]
    });
    // slideJumpTo('.slide_master', `.variant-${LIQUID_firstLoadVariantId}`);
  }
  function handleBtnWishList() {
    var $realBtnSelector = '.swym-add-to-wishlist';
    var $fakeBtnSelector = '.btn-wishlist';

    if (window._swat && typeof window._swat.initializeButtons === 'function') {
      window._swat.initializeButtons();
    }

    function updateFakeBtns() {
      var isAdded = false;
      var $realBtns = $($realBtnSelector);
      
      $realBtns.each(function() {
        var $btn = $(this);
        if (($btn.hasClass('swym-added') || $btn.hasClass('atw-button-added')) && !$btn.hasClass('swym-removing')) {
          isAdded = true;
          return false;
        }
      });

      $($fakeBtnSelector).each(function () {
        var $this = $(this);
        var $span = $this.find('span');
        
        $this.toggleClass('active', isAdded);
        $span.text(isAdded ? 'ウィッシュリストに追加済み' : 'ウィッシュリストに追加');
      });
    }

    var detectObserver = new MutationObserver(function () {
      var $realBtn = $($realBtnSelector);
      if ($realBtn.length) {
        $realBtn.each(function() {
          var btn = this;
          if (!btn._observed) {
            btn._observed = true;
            var classObserver = new MutationObserver(updateFakeBtns);
            classObserver.observe(btn, { attributes: true, attributeFilter: ['class'] });
            
            $(btn).on('click', function() {
              setTimeout(updateFakeBtns, 300);
            });

            updateFakeBtns();
          }
        });
      }
    });

    detectObserver.observe(document.body, { childList: true, subtree: true });

    if (!window._swatListenersSet) {
      window.addEventListener('swym:item-added', updateFakeBtns);
      window.addEventListener('swym:item-removed', updateFakeBtns);
      window.addEventListener('swym:wishlist-changed', updateFakeBtns);
      window._swatListenersSet = true;
    }
    
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(updateFakeBtns);

    if (!$(document).data('btn-wishlist-init')) {
      $(document).on('click', $fakeBtnSelector, function (e) {
        e.preventDefault();
        var $this = $(this);
        var isCurrentlyActive = $this.hasClass('active');

        $($fakeBtnSelector).toggleClass('active', !isCurrentlyActive);
        $($fakeBtnSelector).find('span').text(!isCurrentlyActive ? 'ウィッシュリストに追加済み' : 'ウィッシュリストに追加');

        if (isCurrentlyActive) {
          $($realBtnSelector).removeClass('swym-added swym-added-button atw-button-added');
        }

        var $realBtn = $this.closest('.form_handle').find($realBtnSelector);
        
        if ($realBtn.length) {
          $realBtn.first().trigger('click');
          setTimeout(updateFakeBtns, 500);
          setTimeout(updateFakeBtns, 1200);
          setTimeout(updateFakeBtns, 2500);
        } else {
          $($realBtnSelector).first().trigger('click');
          setTimeout(updateFakeBtns, 500);
        }
      });
      $(document).data('btn-wishlist-init', true);
    }

    updateFakeBtns();
  }
  

  function checkLogin() {
    if (!customer) {
      window.location.href = '/account/login?return_to=' + encodeURIComponent(window.location.pathname + window.location.search);
      return;
    }
  }
  function toggleSoldOutButton(isSoldOut) {
    const $addToCartButton = $('.add_cart');
    if (isPreOrder()) {
      return;
    }
    if (!isSoldOut) {
      $addToCartButton.text('SOLD OUT');
      $addToCartButton.addClass('sold_out');

    } else {
      $addToCartButton.removeClass('sold_out');
      $addToCartButton.prop('disabled', false);
      $addToCartButton.text('カートに入れる');
    }
  }
  // URLからvariantパラメータを読み取って自動的にvariantを選択する関数
  function handleVariantFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantIdParam = urlParams.get('variant');
    if (variantIdParam) {
      // variantIdを数値に変換（URLパラメータは文字列）
      const numericVariantId = parseInt(variantIdParam.toString().replace(/[^0-9]/g, ''));
      
      if (!isNaN(numericVariantId)) {
        // productVariantsから該当するvariantを検索
        const variant = productVariants.find(function (v) {
          const vId = typeof v.id === 'string' 
            ? parseInt(v.id.toString().replace(/[^0-9]/g, '')) 
            : v.id;
          return vId === numericVariantId;
        });
        
        if (variant && variant.options && Array.isArray(variant.options)) {
          // まず、すべてのvariantボタンのactiveクラスを削除
          $('#introduce .variant button').removeClass('active');
          
          // 各オプションのボタンを選択
          variant.options.forEach(function (optionValue, index) {
            // 各variant_item内で該当するオプション値を探す
            const $variantItems = $('#introduce .variant .variant_item');
            if ($variantItems.length > index) {
              const $variantItem = $variantItems.eq(index);
              const $buttons = $variantItem.find('button');
              
              $buttons.each(function () {
                const $btn = $(this);
                const buttonText = $btn.text().trim();
                if (buttonText === optionValue) {
                  $btn.addClass('active');
                }
              });
            }
          });
          
          // updateDecisionを呼び出して商品名や価格を更新
          // 少し遅延を入れてDOMが更新されるのを待つ
          setTimeout(function() {
            updateDecision(variant, false);
          }, 100);
        }
      }
    }
    else{
      const variant = productVariants.find(v => v.id === LIQUID_firstLoadVariantId);
      handlePreorder(variant);
    }
  }

  function handleVariantSelector() {
    $('.variant button').on('click', function () {
      const $thisBtn = $(this);
      const currentSelect = $thisBtn.data('value');
      const currentList = $thisBtn.parent().attr('class');
      $(`.variant .${currentList} button`).removeClass('active')
      $(`.variant .${currentList} button[data-value="${currentSelect}"]`).addClass('active');

      const optionsArray = [];
      $('#introduce .variant button.active').each(function () {
        optionsArray.push($(this).text().trim());
      });
      var currentVariant = productVariants.find(function (v) {
        return Array.isArray(v.options) &&
          v.options.length === optionsArray.length &&
          v.options.every(function (opt, i) {
            return opt === optionsArray[i];
          });
      });

      if (!currentVariant) {
         let optionIndex = -1;
         let clickedOptionText = "";
         
         $('#introduce .variant .variant_item').each(function(idx) {
             if ($(this).find(`button[data-value="${currentSelect}"]`).length > 0) {
                 optionIndex = idx;
                 clickedOptionText = $thisBtn.text().trim();
             }
         });
         
         if (optionIndex !== -1) {
             let bestVariant = null;
             let maxScore = -1;

             productVariants.forEach(function(v) {
                 if (!v.options || v.options[optionIndex] !== clickedOptionText) return;
                 let score = 0;
                 if (v.available) score += 1000;
                 
                 for(let i = 0; i < v.options.length; i++) {
                     if (i !== optionIndex && v.options[i] === optionsArray[i]) {
                         score += 10;
                     }
                 }
                 
                 if (score > maxScore) {
                     maxScore = score;
                     bestVariant = v;
                 }
             });

             if (bestVariant) {
                 currentVariant = bestVariant;
                 
                 currentVariant.options.forEach(function(optText, idx) {
                     const $introItem = $('#introduce .variant .variant_item').eq(idx);
                     $introItem.find('button').removeClass('active').filter(function() {
                         return $(this).text().trim() === optText;
                     }).addClass('active');
                     
                     const $secondItem = $('#second_handle .variant .variant_item').eq(idx);
                     $secondItem.find('button').removeClass('active').filter(function() {
                         return $(this).text().trim() === optText;
                     }).addClass('active');
                 });
             }
         }
      }

      $('input[type="number"].input_quantity').val(1);
      $('.add_cart').attr('data-quantity', 1);
      updateOverlaySnapshot();
      updateDecisionDebounce(currentVariant);
    });
  }
  const updateDecisionDebounce = Utils.debounce(function (variant) {
    updateDecision(variant);
  }, 300);
  
  /**
   * Slide to target
   * @param {string} slideClass - The class of the slide container
   * @param {string} targetClass - The class of the target slide
   */
  function slideJumpTo(slideClass, targetClass) {
    var index = $(`${slideClass} ${targetClass}`).data('slick-index');
    if (index === undefined) return;
    $(`${slideClass}`).slick('slickGoTo', index);
  }

  function handleMediaVariant() {
    productVariants.forEach(function (variant) {
      const mediaID = variant.featured_media ? variant.featured_media.id : null;
      if (mediaID) {
        $(`.slide_master .slide_item[data-media-id="${mediaID}"]`).addClass(`variant-${variant.id}`);
      }
    });
  };
  function isPreOrder() { 
    return $('#introduce form').hasClass('showProductPreorder');
   }


  function updatePreorderLimit() {
    if (isPreOrder){
      const preorderLimit = $('.gInputElement').attr('preorder-limit');
      const $inputs = $('input[type="number"].input_quantity');
        if (!preorderLimit | preorderLimit <= 0) {
          $inputs.each(function () {
            $(this).removeAttr('max');
          });
          return;
        }
        $inputs.each(function () {
          $(this).attr('max', preorderLimit);
        });
      
    }
  }
  function handleQuantitySelector() {
    const $inputs = $('input[type="number"].input_quantity');

    // Helper: Validate and clamp quantity value
    function validateQuantity($input) {
      const min = parseInt($input.attr('min')) || 1;
      const max = parseInt($input.attr('max')) || Infinity;
      let value = parseInt($input.val()) || min;

      if (value < min) value = min;
      if (value > max) value = max;

      $input.val(value);
      return value;
    }

    $('.quantity_selector .btn_plus').on('click', function () {
      $inputs.each(function () {
        const $input = $(this);
        const max = parseInt($input.attr('max')) || Infinity;
        const current = parseInt($input.val()) || 1;

        if (current < max) {
          this.stepUp();
          validateQuantity($input);
          $input.trigger('change');
        }
      });
      updateDecision();
    });

    $('.quantity_selector .btn_minus').on('click', function () {
      $inputs.each(function () {
        const $input = $(this);
        this.stepDown();
        validateQuantity($input);
        $input.trigger('change');
      });
      updateDecision();
    });

    // Validate on input change/blur
    $inputs.on('change blur', function () {
      const qty = validateQuantity($(this));
      // data-quantityを更新
      $('.add_cart').attr('data-quantity', qty);
      updateDecision();
    });

    // Prevent input beyond max on keypress
    $inputs.on('input', function () {
      const $input = $(this);
      const max = parseInt($input.attr('max')) || Infinity;
      const value = parseInt($input.val());

      if (!isNaN(value) && value > max) {
        $input.val(max);
      }
    });
  }

  function updateDecision(currentVariant, isJumpImage = true) {
    if (currentVariant) {
      updateUrl(currentVariant.id);
      $('.product_handle .prod_name').text(currentVariant.name);
      $('.product_handle .price .value').text(Product.formatPrice(currentVariant.price));
      $('.product_handle .add_cart').attr('data-variant-id', currentVariant.id);
      $('.product_handle .add_cart').attr('data-variant-name', currentVariant.public_title);
      $('input[name=quantity]').attr('max', quantityDataset[currentVariant.id].inventory_quantity);
      $('.product_handle .product-variant-id').val(currentVariant.id);
      
      // Swym wishlist buttonのvariant IDを更新
      $('.swym-add-to-wishlist').attr('data-variant-id', currentVariant.id);
      if (isJumpImage){
        slideJumpTo('.slide_master', `.variant-${currentVariant.id}`);
      }
      // toggleSoldOutButton(currentVariant.available);

      // Globo.Preorder.init(GloboPreorderParams);
      // Globo.Preorder.initPreorder();
      // handlePreorder(currentVariant);

    }
  }
  function handlePreorder(currentVariant) {
    let count = 0;
    const interval = setInterval(() => {
      // Double bind cuz 1 not working sometimes
      const $variantIdInput = $('input[name="id"]');
      if ($variantIdInput.length) {
        $variantIdInput.val(currentVariant.id);
        $variantIdInput[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
      count++;
      if (count >= 1) { // stop after running twice
        toggleSoldOutButton(currentVariant.available);
        clearInterval(interval);
      }
    }, 500); // interval time ( <50ms will not work)

  }
  function hideFormButton() {
    const btnForm = $('.form_handle');
    setTimeout(() => {
      btnForm.show();
    }, _duration);
  }
  function updateOverlaySnapshot() {
    $('.form_handle').each(function() {
      const $formHandle = $(this);
      // Clone the current state without events
      const $snapshot = $formHandle.clone(false, false);
      
      // Add identifier class to the snapshot
      $snapshot.addClass('form-snapshot');
      
      // Remove the overlay itself from the snapshot to avoid recursion
      $snapshot.find('.swym-add-to-wishlist').remove();
      
      // Find all forms in the snapshot
      $snapshot.find('form').each(function() {
        const $form = $(this);
        
        // Create a div with the form's HTML content
        let $div = null;
        if ($form.hasClass('showProductPreorder')){
          $div = $('<div class="form_alt">').html($form.html());
        }else{
          $div = $('<div>').html($form.html());
        }
        
        // Clear all input values
        $div.find('input, textarea').val('');
        
        // Reset checkboxes and radio buttons
        $div.find('input[type="checkbox"], input[type="radio"]').prop('checked', false);
        
        // Reset select dropdowns to first option
        $div.find('select').prop('selectedIndex', 0);
        
        // Remove id and class attributes from all elements
        $div.find('*').addBack().each(function() {
          // $(this).removeAttr('id class');
        });
        
        // Replace the form with the div
        $form.replaceWith($div);
      });
    });
  }
  function updateUrl(variantId) {
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
    refreshInfo(variantId);
    refreshHandle(variantId);
  }
  function handleAddCartButton() {
    $(document).on('click', '.add_cart', async function () {
      const $btn = $(this);
      const variantId = $btn.attr('data-variant-id');
      let quantity = $btn.attr('data-quantity');

      if (!variantId || !quantity) {
        alert('Please select a valid product variant.');
        return;
      }

      if (isPreOrder()) {
        quantity = await checkQuantityInCart(variantId, quantity);
        if (quantity === 0) return; 
      } else {
        if ($btn.hasClass('sold_out')) {
          handleModal('申し訳ありませんが、この商品は現在在庫切れです。');
          return;
        }
        handleModal('商品をカートに追加しました。');
      }

      await Cart.addToCart(variantId, quantity, location);
      await Cart.updateCartCount();
    });
  }
  function disableCartForm() {
    $(document).on('submit', 'form[action$="/cart/add"]', function (e) {
      e.preventDefault();
    });
  }
  async function checkQuantityInCart(variantId, addQuantity) {
    const stock = quantityDataset[variantId].inventory_quantity;
    const maxLimit = parseInt($('#introduce input[type="number"].input_quantity').attr('max'));
    const cart = await Cart.getCart();
    const cartItem = cart?.items?.find(i => i.variant_id == variantId);
    
    const currentQty = cartItem ? cartItem.quantity : 0;
    const requestedQty = parseInt(addQuantity);
    const newTotal = currentQty + requestedQty;
    
    // Determine the effective limit based on order type
    let effectiveLimit, limitType;
    
    if (isPreOrder()) {
        if (!maxLimit) {
            // No limit configured for preorder - allow freely
            handleModal('商品をカートに追加しました。');
            return requestedQty;
        }
        effectiveLimit = maxLimit;
        limitType = '予約上限数';
    } else {
        effectiveLimit = stock;
        limitType = '在庫数';
    }
    
    const remaining = effectiveLimit - currentQty;
    
    // Already at limit
    if (currentQty >= effectiveLimit) {
        handleModal(`${limitType}に達しました。これ以上カートに追加できません。`);
        return 0;
    }
    
    // Would exceed limit
    if (newTotal > effectiveLimit) {
        handleModal(`${limitType}を超えています。残り${remaining}点までカートに追加できます。`);
        return remaining;
    }
    
    // Success
    handleModal('商品をカートに追加しました。');
    return requestedQty;
}

function refreshHandle(currentVariant) {
  const url = `${window.location.href}&sections=product-form-handle`;

  fetch(url)
    .then(res => res.json())
    .then(data => {
      let htmlString = data['product-form-handle']; // string
let $html = $(htmlString).find('.add_cart');

$('#shopify-section-product-form-handle .add_cart').remove();
if($('#shopify-section-product-form-handle .btn_group .gInputElement').length > 0){
  $('#shopify-section-product-form-handle .btn_group .gInputElement').before($html);
}else{
  $('#shopify-section-product-form-handle .btn_group').prepend($html);
}
      Globo.Preorder.init(GloboPreorderParams);
      Globo.Preorder.initPreorder();
    })
    .catch(err => {
      console.error('Failed to load section:', err);
    }).then(() => {
      mirrorDom('#introduce .form_handle', '#second_handle .form_handle');
        handleBtnWishList();
        updateOverlaySnapshot();
        setTimeout(() => {
        updatePreorderLimit();
        }, 500);
    });
}

})(jQuery);

async function handleAlsoBought(recommendData) {
  try {
    const engine = new liquidjs.Liquid();
    // Define Shopify-like filters
    engine.registerFilter('money_without_currency', price => {
      return Number(price).toLocaleString();
    });
    let allHtml = '';
    const html = await Promise.all(
      recommendData.map(item =>
        engine.renderFile(rcTpl, { product: item, custom_class: 'slide_item' }) // rcTpl defined in product.liquid
      )
    );
    allHtml = html.join('');

    $('#recommend_prod .recommend_prod_slide').html(allHtml);
    alsoBoughtSilder();

  } catch (err) {
    console.error('Error:', err);
  }
}
observeAlsoBoughtAndGetProducts().then(products => {
    handleAlsoBought(products);
});
function alsoBoughtSilder() {
  slickSlider('.recommend_prod_slide', {
    fade: false,
    autoplay: false,
    arrows: true,
    dots: false,
    autoplaySpeed: 3000,
    adaptiveHeight: true,
    variableWidth: true,
    slidesToShow: 1,
    prevArrow: $('#recommend_prod .btn_prev'),
    nextArrow: $('#recommend_prod .btn_next'),
    responsive: [
      {
        breakpoint: 960,
        settings: {
          centerPadding: '0',
        }
      }
    ]
  });
}
function mirrorDom(sourceSelector, targetSelector) {
  const source = document.querySelector(sourceSelector);
  const target = document.querySelector(targetSelector);

  if (!source || !target) {
    console.error("mirrorDom: source or target not found");
    return;
  }

  const update = () => (target.innerHTML = source.innerHTML);

  update(); // initial clone

}
function refreshInfo(currentVariant) {
  const url = `${window.location.href}&sections=product-variant-picker`;

  fetch(url)
    .then(res => res.json())
    .then(data => {
      const html = data['product-variant-picker'];
      document.querySelector('#shopify-section-product-variant-picker').innerHTML = html;
      const input = document.querySelector('input[name="id"]');
      if (input) {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    disableOptions();
    })
    .catch(err => {
      console.error('Failed to load section:', err);
    });
}

function disableOptions() {
  let unAvailableOptions = getUnavailableOptions();
  $('.variant button').removeClass('disabled');
  unAvailableOptions.forEach(option => {
    $(`.variant button[data-index="${option}"]`).addClass('disabled')
  })
}

function getUnavailableOptions() {
  const el = document.getElementById("product-data");
  return JSON.parse(el.dataset.unavailableOptions);
}
